document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const cartParam = params.get('cart');
  const redirectUrl = params.get('redirect_to');

  if (cartParam) {
    const items = cartParam.split(',');

    if (items.length === 0) return;

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro ao limpar o carrinho');
        }
        return response.json();
      })
      .then((data) => {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: items.map((item) => {
              const [variantId, quantity] = item.split(':');
              return {
                id: Number(variantId),
                quantity: Number(quantity),
              };
            }),
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Erro ao adicionar itens ao carrinho');
            }
            return response.json();
          })
          .then((data) => {
            window.location.href = redirectUrl || '/cart'
          });
      })
      .catch((error) => {
        console.error('Erro:', error);
      });
  }
});